<template>
  <div>
    <section-header
      id="bills"
      :departmentId="departmentId"
      :swiftMove="swiftMove"
      >Bills</section-header
    >
    <v-btn v-if="addBillStatus == false" @click="addBillStatus = true" small>
      <v-icon>add</v-icon> Bill
    </v-btn>
    <div class="ajaxForm" v-if="addBillStatus == true">
      <h1>Add bill</h1>
      <p>Choose template to add projection</p>
      <ul>
        <li v-for="billTemplate in billTemplates" :key="billTemplate.id">
          <a @click="createBill(billTemplate)">{{ billTemplate.name }}</a>
        </li>
      </ul>
      <hr />
      <v-btn @click="addBillStatus = false">Cancel</v-btn>
    </div>
    <div class="bills">
      <div class="bill" v-for="bill in modifiedBills" :key="bill.id">
        <div class="bill--content">
          <div class="bill--archived" v-if="bill.archived">
            <Bill :id="bill.id" />
            <span>-</span>
            {{ bill.billprojection }}
            <span>-</span>
            {{ bill.timestamp | formatDateTime }}
            <span>-</span>
            <a @click="updateBillArchived(bill, false)">undelete</a>
          </div>
          <div class="bill--unarchived" v-if="!bill.archived">
            <img
              alt="#{bill.billprojection}"
              :src="require(`@/assets/events/calculator.jpg`)"
              class="bill--logo"
            />
            <div class="bill--info">
              <Bill :id="bill.id" />
              <div>
                {{ bill.billprojection }} -
                <strong>{{ bill.total | toCurrency }}</strong>
              </div>
              <div>
                <EntityZ :entity="bill.user" v-if="bill.user" />
                <span v-if="!bill.user">{{ bill.userid }}</span>
                {{ bill.timestamp | formatDateTime }}
              </div>
            </div>
          </div>
          <div>
            <div>
              <span v-if="bill.frozen">frozen</span>
              <a
                v-if="!bill.frozen || $keycloak.hasRealmRole('root')"
                @click="toggleBillFrozen(bill)"
                >freeze</a
              >
              <span>&#160;|&#160;</span>
              <a @click="cloneBill(bill)">clone</a>
              <span>&#160;|&#160;</span>
              <a @click="updateBillArchived(bill, true)">delete</a>
            </div>
            <p>
              <a @click="updateBillTracker(bill)">Visible on tracker</a>
              <span>:</span>
              <span :class="booleanStrongStyle(bill.tracker)">{{
                booleanConverter(bill.tracker)
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bill from "@/components/link/Bill";
import EntityZ from "@/components/link/EntityZ";
import SectionHeader from "@/components/file/SectionHeader";
import { booleanStrongStyle, booleanConverter } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Bills",
  components: {
    Bill,
    EntityZ,
    SectionHeader
  },
  props: ["departmentId", "swiftMove"],
  computed: {
    modifiedBills() {
      if (!this.bills) {
        return undefined;
      }
      return this.bills.map((b) => {
        const user = this.entities ? this.entities[b.userid] : undefined;
        return {
          ...b,
          user
        };
      });
    }
  },
  data() {
    return {
      addBillStatus: false,
      bills: null,
      billTemplates: null,
      entities: null
    };
  },
  methods: {
    booleanStrongStyle,
    booleanConverter,
    async fetchBills() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/bills`
      );
      // console.log(response.data)
      this.bills = response.data;
    },
    async fetchBillTemplates() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/billTemplates`
      );
      // console.log(response.data)
      this.billTemplates = response.data;
    },
    async fetchEntities() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/bills/users`
      );
      // console.log(response.data)
      this.entities = response.data;
    },
    async createBill(billTemplate) {
      const response = await nbmlaw.post(
        `/cors/admin/file/files/${this.$route.params.id}/bills/${billTemplate.id}`,
        null
      );
      // console.log(response.data)
      this.$router.push({
        name: "bill",
        params: {
          id: response.data
        }
      });
      this.addBillStatus = false;
    },
    async updateBillTracker(bill) {
      await nbmlaw.put(
        `/cors/admin/bill/bills/${bill.id}/tracker/${!bill.tracker}`,
        null
      );
      // console.log(response.data)
      this.fetchBills();
    },
    async toggleBillFrozen(bill) {
      await nbmlaw.put(
        `/cors/admin/bill/bills/${bill.id}/frozen/${!bill.frozen}`,
        null
      );
      // console.log(response.data)
      this.fetchBills();
    },
    async cloneBill(bill) {
      const response = await nbmlaw.post(
        `/cors/admin/file/files/${this.$route.params.id}/bills/${bill.id}/clone`,
        null
      );
      // console.log(response.data)
      this.$router.push({
        name: "bill",
        params: {
          id: response.data
        }
      });
      this.addBillStatus = false;
    },
    async updateBillArchived(bill, value) {
      if (confirm("Are you sure?")) {
        await nbmlaw.put(
          `/cors/admin/bill/bills/${bill.id}/archive/${value}`,
          null
        );
        // console.log(response.data)
        this.fetchBills();
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchBillTemplates();
        this.fetchBills();
        this.fetchEntities();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bills {
  display: flex;
  flex-direction: column;
}

.bill {
  &:nth-child(even) {
    background: #fff;
  }
  &:nth-child(odd) {
    background: #ddd;
  }
  &--content {
    padding: 1rem;
    display: flex;
    flex-direction: row;
  }
  &--archived {
    display: flex;
    flex-direction: row;
    padding: 2px;
    font-size: 0.8em;
    text-decoration: line-through;
  }
  &--unarchived {
    display: flex;
    flex-direction: row;
    flex: 1;
  }
  &--logo {
    height: 45px;
    width: 45px;
    border: 1px solid gray;
    margin-right: 1rem;
  }
}
</style>
